/*
 * Valoured — <v-owner-access> (custom). Opens the hidden owner password dialog
 * from a private URL hash, a typed secret word, or an optional invisible hotspot.
 * Re-opens automatically after a wrong password so the error is seen.
 */
if (!customElements.get('v-owner-access')) {
  customElements.define(
    'v-owner-access',
    class VOwnerAccess extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.hash = (this.dataset.hash || '').toLowerCase();
        this.word = (this.dataset.word || '').toLowerCase();
        this.typed = '';

        this.onHash = () => {
          if (this.hash && window.location.hash.slice(1).toLowerCase() === this.hash) this.open();
        };
        this.onKey = (event) => {
          if (!this.word || this.dialog.open || event.metaKey || event.ctrlKey || event.altKey) return;
          if (event.target.closest?.('input, textarea, select, [contenteditable="true"]')) return;
          if (event.key.length !== 1) return;
          this.typed = (this.typed + event.key.toLowerCase()).slice(-this.word.length);
          if (this.typed === this.word) {
            this.typed = '';
            this.open();
          }
        };
        this.onClick = (event) => {
          if (event.target.closest('[data-v-owner-open]')) this.open();
          if (event.target.closest('[data-v-owner-close]')) this.close();
          // Click on the backdrop (outside the form) closes.
          if (event.target === this.dialog) this.close();
        };

        window.addEventListener('hashchange', this.onHash);
        document.addEventListener('keydown', this.onKey);
        this.addEventListener('click', this.onClick);

        if (this.querySelector('[data-v-owner-error]')) this.open();
        else this.onHash();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHash);
        document.removeEventListener('keydown', this.onKey);
        this.removeEventListener('click', this.onClick);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.dialog.querySelector('input[type="password"]')?.focus();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }
    }
  );
}
